import { useGetCompanyListCompanyGet } from "kubb";
import type React from "react";
import { useContext, useEffect } from "react";
import PageSpinner from "../../components/Spinners/PageSpinner";
import { CompanyContext } from "../../reducers/company";
import CompanySelectInit from "./CompanySelectInit";

export default function CompanyListInit(props: {
  children: React.ReactNode;
}): React.ReactElement {
  const { state, dispatch } = useContext(CompanyContext);

  // TODO: paginate or move to server-side search once company count approaches
  // this ceiling — the global selector fetches the full list once and filters
  // client-side, so it silently truncates above max_items.
  const { data, isLoading, error } = useGetCompanyListCompanyGet(
    {
      max_items: 1000,
    },
    {
      query: {
        staleTime: 5 * 60 * 1000,
      },
    },
  );

  useEffect(() => {
    if (data !== undefined) {
      dispatch({ type: "LOADING_COMPANIES_SUCCESS", payload: data.data });
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (isLoading) {
      dispatch({ type: "LOADING_COMPANIES_STARTED" });
    }
  }, [isLoading, dispatch]);

  useEffect(() => {
    if (error) {
      dispatch({ type: "LOADING_COMPANIES_ERROR", payload: error });
    }
  }, [error, dispatch]);

  return (
    <>
      <PageSpinner spin={isLoading}>
        {!isLoading && state.companies && (
          <CompanySelectInit>{props.children}</CompanySelectInit>
        )}
      </PageSpinner>
    </>
  );
}
